export default function Footer() {
  return (
    <div className="flex justify-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <p className='py-6 text-sm text-gray-300'>© {(new Date().getFullYear())} NBS Marketing Realty. All rights reserved.</p>
    </div>
  )
}
